<template>

  <div class="inline-block" id="summary">
    <h3 style="margin-bottom: 5pt;">分類別平均</h3>
    <table>
      <colgroup>
        <col style="width:5mm;" />
        <col style="width:25mm;" />
        <col style="width:10mm;" />
        <col style="width:10mm;" />
        <col style="width:10mm;" />
        <col style="width:20mm;" />
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2">No</th>
          <th rowspan="2">分類</th>
          <th colspan="3">平均</th>
          <th>平均点分布</th>
        </tr>
        <tr>
          <th>本人</th>
          <th>協力者</th>
          <th>差分</th>
          <th>
            本人
            <div class="v-square"></div>協力者
            <div class="v-diamond"></div>
          </th>
        </tr>
      </thead>
      <tr v-for="(item, i) in items" :key="i">
        <td>{{i +1}}</td>
        <td>{{item.category}}</td>
        <td class="text-right">{{item.selfs}}</td>
        <td class="text-right">{{item.meanScore}}</td>
        <td class="text-right">{{item.diffSelfAndmeanScore}}</td>
        <td>
          <ho-bar-chart
            :forPrint="false"
            class="chart1"
            :value="item.meanScore"
            :marker="item.selfs"
            :ops="ops"
            :chartWidth="135"
            :isScaleDisplayed="i==0"
          />
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import HoBarChart from "@/components/result_print/horizontal_bar_chart.vue";
import { mean, standardDeviation, max } from "simple-statistics";
export default {
  components: { HoBarChart },
  props: {
    values: {
      required: true
    },
    ops: {
      required: true
    },
    categories: {
      required: false,
    }
  },
  data() {
    return {
      numOfOptions: this.ops.length,
      items: []
    };
  },
  computed: {
    // items() {
    //   return Object.keys(this.values).map(k => {
    //     const v = this.values[k];
    //     const avg = this.round(mean(v.score), 2);
    //     const selfsAvg = this.round(mean(v.selfs), 2);
    //     return {
    //       category: v.category,
    //       selfs: selfsAvg,
    //       score: v.score,
    //       meanScore: avg,
    //       diffSelfAndmeanScore: this.round(avg - selfsAvg, 2),
    //       sdScore: this.round(standardDeviation(v.score), 2),
    //       frequency: this.frequency(v.score)
    //     };
    //   });
    // }
  },
  mounted() {
    this.items = this.getItems();
  },
  watch: {
    values() {
      this.items = this.getItems();
    }
  },
  methods: {
    frequency(score) {
      let dist = Array(this.numOfOptions).fill(0);
      score.forEach(e => (dist[e - 1] = dist[e - 1] + 1));
      return dist;
    },
    round(value, demical) {
      const n = Math.pow(10, demical);
      return (Math.round(value * n) / n).toFixed(demical);
    },
    getItems() {
      return this.categories.map(k => {
        const v = this.values[k];
        const avg = this.round(mean(v.score), 2);
        const selfsAvg = this.round(mean(v.selfs), 2);
        return {
          category: v.category,
          selfs: selfsAvg,
          score: v.score,
          meanScore: avg,
          diffSelfAndmeanScore: this.round(avg - selfsAvg, 2),
          sdScore: this.round(standardDeviation(v.score), 2),
          frequency: this.frequency(v.score)
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.text-right{
  text-align: right;
  padding-right: 3px;
}
.inline-block {
  display: inline-block;
}
#summary {
  width: 90mm;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.50);
    font-size: 8px;
  }
  td {
    word-wrap: break-word;
    padding: 1pt;
  }
  tr {
    height: 3mm;
  }
}
th.first-row {
  border-bottom: none;
}
th.second-row {
  border-top: none;
}
.v-square {
  -webkit-print-color-adjust: exact;
  background-color: red !important;
  width: 4px;
  height: 4px;
  margin: 2px;
  display: inline-block;
}
.v-diamond {
  -webkit-print-color-adjust: exact;
  background-color: blue !important;
  width: 3px;
  height: 3px;
  margin: 2px;
  display: inline-block;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0 100%;
  -moz-transform-origin: 0 100%;
  -ms-transform-origin: 0 100%;
  -o-transform-origin: 0 100%;
  transform-origin: 0 100%;
}
</style>